import { isString } from 'util'

const moment = require('moment')
const Rainbow = require('rainbowvis.js')
let colorRainbow = new Rainbow()

let utils = {}

/**
 * Colors domain used to display charts
 */
utils.colorsDomain2 = function() {
  return [
    '#00afb4',
    '#ef4683',
    '#00afe6',
    '#ce74af',
    '#ffc546',
    '#80479c',
    '#f47a4e',
    '#7ec242',
    '#1b75bc',
    '#cc9900',
    '#577a9a',
    '#b8d217',
    '#122e5e',
    '#16726e',
    '#FF5733',
    '#5E33FF',
    '#FF33DA',
    '#E3FF33',
  ]
}

utils.colorsDomain = function() {
  return [
    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    //TO ADD

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',

    '#00c9dc',
    '#C89EFD',
    '#dce83c',
    '#91F162',
    '#FFAA61',
    '#dc6b93',

    '#B7FCFF',
    '#FCA5F1',
    '#CCF982',
    '#EDB8F4',
    '#cd872b',
    '#00FFA1',

    '#CEF7A0',
    '#1BFFFF',
    '#f77062',
    '#C89EFD',
    '#FFC068',
    '#FF6B93',
  ]
}

/**
 *
 */
utils.colorSet = function(sortBy) {
  let colorSet = []
  let configFilters = JSON.parse(localStorage.getItem('filtersConfig'))

  if (sortBy !== 'all' && sortBy !== 'duration') {
    colorSet = {
      '0': '#63E2FF',
      others: '#63E2FF',
    }

    for (let i = 0; i < configFilters.filter_values[sortBy].length; i++) {
      colorSet[String(configFilters.filter_values[sortBy][i])] = this.colorsDomain()[i]
    }
  } else if (sortBy == 'duration') {
    colorSet = {
      '- 30 min': this.colorsDomain()[0],
      '30 min - 1h': this.colorsDomain()[1],
      '1h - 1h30': this.colorsDomain()[2],
      '1h30 - 2h': this.colorsDomain()[3],
      '2h - 2h30': this.colorsDomain()[4],
      '2h30 - 3h': this.colorsDomain()[5],
      '3h - 3h30': this.colorsDomain()[6],
      '3h30 - 4h': this.colorsDomain()[7],
      '+ 4h': this.colorsDomain()[8],
      others: '#63E2FF',
    }
  } else {
    colorSet = {
      all: '#63E2FF',
    }
  }

  return colorSet
}

/**
 * Color sets used according to data types
 */
utils.colorSet2 = function(sortBy, configFilters) {
  let colorSet = []

  let start = 0

  switch (sortBy) {
    case 'site_id':
    case 'site_location':
      colorRainbow.setSpectrum('#A6E69D', '#00B6D6')
      break
    case 'language':
      //colorRainbow.setSpectrum("#D585FF", "#00FFEE");
      //colorRainbow.setSpectrum("#FEA9A9", "#FFF7AF", "#C1FFB1", "#A8D8FA", "#EECEFD"); //GOOD
      //colorRainbow.setSpectrum("#fef9d7", "#FFBAC3", "#C5C1FF", "#2CD8D5", "#fef9d7"); //GOOD
      //colorRainbow.setSpectrum("#9795f0", "#fbc8d4", "#d1fdff", "#f9f586") //NOT BAD
      //colorRainbow.setSpectrum("#fef9d7", "#d299c2", "#5ee7df", "#b490ca", "#96fbc4", "#f9f586"); //NOT BAD
      colorRainbow.setSpectrum('#d299c2', '#f9f586', '#2af598', '#009efd', '#9795f0', '#fbc8d4')
      break
    case 'collected_treasure_count':
      start = 1
      colorRainbow.setSpectrum('#FCA5F1', '#B5FFFF')
      break
    case 'duration':
      colorRainbow.setSpectrum('#FFF858', '#FF6B6B')
      break
    case 'histopad_rating':
    case 'visit_rating':
      start = 1
      colorRainbow.setSpectrum('#FD807A', '#FFFA87', '#9DFF85')
      break
  }

  if (sortBy != 'all' && sortBy != 'duration') {
    colorRainbow.setNumberRange(start, configFilters.filter_values[sortBy].length - 1)
    colorSet = {
      '0': '#5AD8FB',
      others: '#5AD8FB',
    }

    for (let i = start; i < configFilters.filter_values[sortBy].length; i++) {
      colorSet[String(configFilters.filter_values[sortBy][i])] = '#' + colorRainbow.colorAt(i)
    }
  } else if (sortBy == 'duration') {
    colorRainbow.setNumberRange(0, 8)
    colorSet = {
      '< 30 min': '#' + colorRainbow.colorAt(0),
      '30 min - 1h': '#' + colorRainbow.colorAt(1),
      '1h - 1h30': '#' + colorRainbow.colorAt(2),
      '1h30 - 2h': '#' + colorRainbow.colorAt(3),
      '2h - 2h30': '#' + colorRainbow.colorAt(4),
      '2h30 - 3h': '#' + colorRainbow.colorAt(5),
      '3h - 3h30': '#' + colorRainbow.colorAt(6),
      '3h30 - 4h': '#' + colorRainbow.colorAt(7),
      '> 4h': '#' + colorRainbow.colorAt(8),
      others: '#5AD8FB',
    }
  } else {
    colorSet = {
      all: '#5AD8FB',
    }
  }

  return colorSet
}

/**
 * Generate API path to call according to the chart config
 * @param {*} config
 * @param {*} start
 * @param {*} end
 * @param {*} user
 * @param {*} area
 */
utils.pathGenerator = function(config, start, end, dateFormat, user, area) {
  let chartType = config.type.toLowerCase()

  if (
    (chartType.toLowerCase() === 'bar' || chartType.toLowerCase() === 'pie') &&
    config.distribution_type &&
    config.distribution_type !== ''
  ) {
    chartType = 'pie'
  } else if (chartType.toLowerCase() === 'bar' || chartType.toLowerCase() === 'pie') {
    chartType = 'indicator'
  }

  let path =
    chartType +
    '?dataType=' +
    config.data_type.toLowerCase() +
    '&dataValue=' +
    config.data_value.toLowerCase() +
    '&sortBy=' +
    config.sort_by.toLowerCase() +
    '&startDate=' +
    moment(start, dateFormat).format('YYYY-MM-DD') +
    '&endDate=' +
    moment(end, dateFormat).format('YYYY-MM-DD')

  if (area != null && isString(area)) {
    path += '&area=' + area
  }

  let filters = JSON.parse(JSON.stringify(config.filters))

  if (user.userRole.name === 'partner') {
    let sites = Array.from(user.sites, s => {
      return '' + s.site
    })

    let filterSiteIds = filters.find(filter => {
      return filter.type === 'site_location'
    })

    if (filterSiteIds !== undefined && filterSiteIds.values.length > 0) {
      filterSiteIds.values = filterSiteIds.values.filter(id => {
        return sites.indexOf('' + id) > -1
      })
    } else {
      filters.push({
        type: 'site_location',
        values: sites,
      })
    }
  }

  if (filters.length > 0) {
    filters
      .filter(filter => filter.type !== 'site_id')
      .forEach(filter => {
        path += '&' + filter.type.toLowerCase() + '=' + filter.values.toString()
      })
  }

  return path
}

/**
 * Use to return a chart title according to his configuration
 */
utils.chartTitleGenerator = function($t, config) {
  let chartTitle = ''

  if (config.data_type == 'distribution') {
    chartTitle +=
      $t('titles.distribution.' + config.data_value) +
      ' ' +
      $t('by') +
      ' ' +
      String($t('filter.' + config.distribution_type)).toLowerCase()
  } else if (
    config.data_value == 'hotspot' ||
    config.data_value == 'cartel' ||
    config.data_value == 'immersive' ||
    config.data_value == 'augmentedvisit' ||
    config.data_value == 'interactiveobject'
  ) {
    chartTitle = $t('titles.' + config.type + '.' + config.data_type + '.' + config.data_value, [
      String($t('chart.data_value.' + config.data_value)).toLowerCase(),
    ])
  } else {
    chartTitle = $t('titles.' + config.type + '.' + config.data_type + '.' + config.data_value)
  }

  if (config.sort_by != 'all' && config.sort_by && config.data_value != 'battery_lifetime') {
    chartTitle += ' ' + $t('by') + ' ' + String($t('filter.' + config.sort_by)).toLowerCase()
  }

  return chartTitle
}

export default utils
